var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBankDocument = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.93 0H40.073C49.34 0 54.5 5.34 54.5 14.49V45.48C54.5 54.78 49.34 60 40.073 60H14.93C5.81 60 0.5 54.78 0.5 45.48V14.49C0.5 5.34 5.81 0 14.93 0ZM15.74 13.98V13.95H24.707C26 13.95 27.05 15 27.05 16.287C27.05 17.61 26 18.66 24.707 18.66H15.74C14.447 18.66 13.4 17.61 13.4 16.32C13.4 15.03 14.447 13.98 15.74 13.98ZM15.74 32.22H39.26C40.55 32.22 41.6 31.17 41.6 29.88C41.6 28.59 40.55 27.537 39.26 27.537H15.74C14.447 27.537 13.4 28.59 13.4 29.88C13.4 31.17 14.447 32.22 15.74 32.22ZM15.74 45.93H39.26C40.457 45.81 41.36 44.787 41.36 43.59C41.36 42.36 40.457 41.34 39.26 41.22H15.74C14.84 41.13 13.97 41.55 13.49 42.33C13.01 43.08 13.01 44.07 13.49 44.85C13.97 45.6 14.84 46.05 15.74 45.93Z",
    fill: "#CBCBCB"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBankDocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bankDocument.2f1ca83a.svg";
export { ForwardRef as ReactComponent };